import { render, staticRenderFns } from "./bigNumVertical.vue?vue&type=template&id=147c3978&scoped=true&"
import script from "./bigNumVertical.vue?vue&type=script&lang=js&"
export * from "./bigNumVertical.vue?vue&type=script&lang=js&"
import style0 from "./bigNumVertical.vue?vue&type=style&index=0&id=147c3978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c3978",
  null
  
)

export default component.exports